import Layout from '@/AppMain.vue';

const integration = {
    path: '/integration',
    name: 'Integration',
    component: Layout,
    children:[
        {
            path: '/integration',
            name: 'Integration',
            component: () => import('@/views/integrations/browse'),
            meta: {title: 'Integration', auth: true, name:'Integration', middlewares:['activeWebsite']}
        },
        {
            path: '/integration/:type',
            name: 'Integration',
            component: () => import('@/views/integrations/edit_add_integration'),
            meta: {title: 'Integration', auth: true, name:'Integration', middlewares:['activeWebsite']}
        },
        {
            path: '/integration/manage/:id',
            name: 'Integration',
            component: () => import('@/views/integrations/single-integration-view/holder'),
            meta: {title: 'Integration', auth: true, name:'Integration', middlewares:['activeWebsite']}
        },
        {
            path: '/integration/manage/:id/:tab',
            name: 'Integration',
            component: () => import('@/views/integrations/single-integration-view/holder'),
            meta: {title: 'Integration', auth: true, name:'Integration', middlewares:['activeWebsite']}
        }
    ]
};
export default integration;
